export var ENTITY = "insurance";
export var REDUCER_KEY = "INSURANCE_V2";
export var BASE_PATH_ENTITY = "insurances";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
